import {
  $getRoot,
  $getSelection,
  $isRangeSelection,
  $createParagraphNode,
  $parseSerializedNode,
} from "lexical";
import { $createPageNode, $isPageNode } from "../nodes/PageNode.jsx";

export function $getCurrentPage() {
  const sel = $getSelection();
  let n = $isRangeSelection(sel)
    ? sel.anchor.getNode()
    : $getRoot().getLastChild();
  while (n && !$isPageNode(n)) n = n.getParent();
  return n || $getRoot().getFirstChild();
}

export function $addPage() {
  const cur = $getCurrentPage();
  const page = $createPageNode();
  const p = $createParagraphNode();
  page.append(p);
  cur.insertAfter(page);
  p.select();
}

export function $movePage(dir) {
  const cur = $getCurrentPage();
  if (dir < 0) {
    const prev = cur.getPreviousSibling();
    if (prev) prev.insertBefore(cur);
  } else {
    const next = cur.getNextSibling();
    if (next) next.insertAfter(cur);
  }
}

export function $deletePage() {
  const cur = $getCurrentPage();
  const neighbour = cur.getNextSibling() || cur.getPreviousSibling();
  cur.remove();
  if (neighbour) neighbour.selectStart();
}

export function $duplicatePage(editor) {
  const cur = $getCurrentPage();
  const json = editor.getEditorState().toJSON().root.children[
    cur.getIndexWithinParent()
  ];
  cur.insertAfter($parseSerializedNode(json));
}

export const pageCount = () => $getRoot().getChildrenSize();
